import { useEffect } from "react";
import "./App.css";
import Head from "./Header";
function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <Head /> */}
      <div className="container main-container" style={{ marginTop: 150 }}>
        <div className="row">
          <div className="col-12">
            <h1 className="policy-head heading-font">Privacy Policy</h1>
            <p>
              Raya Creations values your privacy. This Privacy Policy explains
              how we collect, use, and protect your information.
            </p>
            <b>1. Information We Collect</b>
            <p>
              Personal Information: Name, email address, and account details
              provided during registration. &bull; Usage Data: Information about
              how you interact with the app (e.g., device type, IP address,
              usage frequency).
            </p>

            <b>2. How We Use Your Information</b>

            <p>
              We use your information to: &bull; Provide and improve our
              services. &bull; Communicate updates, offers, and support. &bull;
              Analyze app performance and user behavior.
            </p>

            <b>3. Sharing Your Information</b>

            <p>
              We do not sell, trade, or share your personal information with
              third parties, except: &bull; With trusted partners for
              operational purposes. &bull; When required by law.
            </p>

            <b>4. Data Security</b>

            <p>
              We use industry-standard measures to protect your data. However,
              no method of electronic storage is 100% secure.
            </p>
            <b>5. User Rights</b>
            <p>
              You can access, update, or delete your data at any time by
              contacting us. Opt-out of promotional emails by clicking the
              unsubscribe link in the email.
            </p>

            <b>6. Third-Party Services</b>

            <p>
              Raya Creations may integrate with third-party services (e.g.,
              payment processors or analytics tools). Please review their
              policies for additional details.
            </p>

            <b>7. Changes to Privacy Policy</b>

            <p>
              We may update this policy periodically. Continued use of the app
              constitutes your acceptance of the revised policy.
            </p>

            <b>8. Contact Information</b>

            <p>
              For questions about this Privacy Policy, please contact us at:
              contact@rayacreations.com
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default Privacy;
